import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseMaintenanceEstablishmentChoiceAuctionEntryPauseProps {
  establishmentChoiceId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceEstablishmentChoiceAuctionEntryPause = ({
  establishmentChoiceId,
  options,
}: UseMaintenanceEstablishmentChoiceAuctionEntryPauseProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceEstablishmentChoiceAuctionEntryPause'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/establishment_choice/auction_entries/${establishmentChoiceId}/pause`);
    },
    ...options
  });
}
